export const spinDayData = {
  isAssigningFreeSpins: `Your<br />Free Spins<br />are on the<br />way`,
  needsReLogin: 'Re-login to unlock today’s Free Spins'
};
